// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   TextField,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Box,
//   IconButton,
//   Typography,
//   useTheme,
//   InputLabel,
//   MenuItem,
//   Select,
//   SelectChangeEvent,
//   FormControl,
//   FormHelperText,
// } from '@mui/material';
// import {
//   Close as CloseIcon,
// } from '@mui/icons-material';
// import { gql, useMutation } from '@apollo/client';

// // 1. IMPORT YOUR SVG ICON
// // Make sure the path to your 'formicon.svg' is correct.
// const FORM_ICON_URL = `${process.env.PUBLIC_URL}/formicon.svg`;


// // Defines the structure of data passed to the parent component
// interface NewUserFormData {
//   user: {
//     name: string;
//     email: string;
//   };
//   role: string;
// }

// // Defines the props expected by the UserForm component
// interface UserFormProps {
//   open: boolean;
//   onClose: () => void;
//   onUserAdd: (userData: NewUserFormData) => void;
//   tenantId: string;
// }

// // GraphQL Mutation for adding a user to a tenant
// const ADD_USER_TO_TENANT = gql`
//   mutation AddUserToTenant($input: AddUserToTenantInput!) {
//     addUserToTenant(input: $input) {
//       message
//       invitation {
//         id
//         email
//         nameHint
//         roleInTenant
//         status
//         sentAt
//       }
//     }
//   }
// `;

// const roleDotColors: { [key: string]: string } = {
//   Admin: '#FF9900',
//   Editor: '#0064FF',
//   Viewer: '#6C737F',
// };

// const UserForm: React.FC<UserFormProps> = ({ open, onClose, onUserAdd, tenantId }) => {
//   const theme = useTheme();

//   const [fullName, setFullName] = useState('');
//   const [email, setEmail] = useState('');
//   const [role, setRole] = useState('');

//   const [fullNameError, setFullNameError] = useState('');
//   const [emailError, setEmailError] = useState('');
//   const [roleError, setRoleError] = useState('');
//   const [formError, setFormError] = useState<string | null>(null);

//   const [addUserToTenantMutation, { loading: isAddingUser, error: mutationError }] = useMutation(
//     ADD_USER_TO_TENANT,
//     {
//       onCompleted: (data) => {
//         onUserAdd({
//           user: { name: fullName.trim(), email: email.trim() },
//           role: role,
//         });
//         onClose();
//       },
//       onError: (error) => {
//         setFormError(error.graphQLErrors?.[0]?.message || error.message || 'Failed to add user. Please try again.');
//       },
//     }
//   );

//   useEffect(() => {
//     if (open) {
//       setFullName('');
//       setEmail('');
//       setRole('');
//       setFullNameError('');
//       setEmailError('');
//       setRoleError('');
//       setFormError(null);
//     }
//   }, [open]);

//     // Validation and handler functions remain the same...
//     const validateFullName = (currentName: string): string => {
//         if (!currentName.trim()) return 'Name is required.';
//         return '';
//     };

//     const validateEmail = (currentEmail: string): string => {
//         if (!currentEmail.trim()) return 'Email is required.';
//         if (!/\S+@\S+\.\S+/.test(currentEmail)) return 'Please enter a valid email address.';
//         return '';
//     };

//     const validateRole = (currentRole: string): string => {
//         if (!currentRole.trim()) return 'Role is required.';
//         return '';
//     };

//     const handleFullNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         setFullName(e.target.value);
//         if (fullNameError) setFullNameError(validateFullName(e.target.value));
//     };

//     const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         setEmail(e.target.value);
//         if (emailError) setEmailError(validateEmail(e.target.value));
//     };

//     const handleRoleChange = (event: SelectChangeEvent<string>) => {
//         setRole(event.target.value);
//         if (roleError) {
//             setRoleError(validateRole(event.target.value));
//         }
//     };

//     const handleSubmit = async (event: React.FormEvent) => {
//         event.preventDefault();
//         setFormError(null);

//         const currentFullNameError = validateFullName(fullName);
//         const currentEmailError = validateEmail(email);
//         const currentRoleError = validateRole(role);

//         setFullNameError(currentFullNameError);
//         setEmailError(currentEmailError);
//         setRoleError(currentRoleError);

//         if (currentFullNameError || currentEmailError || currentRoleError) return;
//         if (!tenantId) {
//             setFormError("Tenant information is missing. Cannot add user.");
//             return;
//         }

//         try {
//           await addUserToTenantMutation({
//             variables: { input: { email: email.trim(), name: fullName.trim(), tenantId: tenantId, roleInTenant: role.toLowerCase() } },
//           });
//         } catch (err) {
//           // Handle error
//         }
//     };


//   const isAddUserButtonDisabled = !fullName.trim() || !email.trim() || !role.trim() || isAddingUser;

//   const commonTextFieldSx = {
//     '& .MuiOutlinedInput-root': {
//       borderRadius: '8px',
//       '& fieldset': { borderColor: 'rgba(232, 235, 236, 1)' },
//       '&:hover fieldset': { borderColor: theme.palette.grey[500] },
//     },
//     '& .MuiInputBase-input': {
//         fontSize: '13px', // Or any other size you prefer
//     },
//     '& .MuiInputBase-input::placeholder': {
//         fontSize: '13px', opacity: 1, color: 'rgba(185, 185, 185, 1)', fontFamily: 'Inter'
//     },
//   };

//   const externalLabelSx = {
//     mb: 0.5, fontWeight: 400, fontSize: '12px', color: 'rgba(51, 51, 51, 1)', fontFamily: 'Inter'
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       PaperProps={{
//         component: 'form',
//         onSubmit: handleSubmit,
//         sx: {
//           borderRadius: '16px',
//           maxWidth: '600px',
          
         
//         }
//       }}
//       BackdropProps={{ sx: { backdropFilter: 'blur(5px)' } }}
//       fullWidth
//       sx={{ zIndex: 1301 }}
//     >
//       <DialogTitle sx={{
//   p: theme.spacing(2, 3),
//   // Layer the fade gradient directly on top of the SVG. This is much simpler.
//   backgroundImage: `
//     linear-gradient(to bottom, transparent 80%, white 100%),
//     url('/blue-bg-form.svg')
//   `,
//   backgroundRepeat: 'no-repeat',
//   backgroundPosition: 'center',
//   backgroundSize: 'cover',
//   borderTopRightRadius: '16px',
//   borderTopLeftRadius: '16px',
// }}>
//   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//       <Box 
//         component="span" 
//         sx={{ 
//           mt: 3, 
//           width: 48, 
//           height: 48, 
//           borderRadius: '8px', 
//           display: 'flex', 
//           alignItems: 'center', 
//           justifyContent: 'center', 
//           mr: 1.5, 
//           backgroundColor:'#E5EFFF', 
//           boxShadow: '0px 1px 2px 0px rgba(10, 13, 18, 0.05)' 
//         }}
//       >
//         <img src={FORM_ICON_URL} alt="Form Icon" style={{ width: '24px'}} />
//       </Box>
//       <Box>
//         {/*
//           CHANGE 1: Set a dark color for the main title for high contrast.
//         */}
//         <Typography 
//           variant="h6" 
//           component="div" 
//           sx={{ 
//             fontFamily:'Inter',
//             fontWeight: 600, 
//             fontSize: '16px',
//             mb:0.3, 
//             mt: 3,
//             color: 'rgba(3, 23, 52, 1)' // Dark blue color for title
//           }}
//         >
//           Add New User
//         </Typography>
//         {/*
//           CHANGE 2: Set a dark grey color for the subtitle.
//         */}
//         <Typography 
//           variant="body2" 
//           color="text.secondary" 
//           sx={{ 
//             fontFamily:'Inter',
//             fontSize: '14px',
//             fontWeight: 400,
//             color: 'rgba(71, 84, 103, 1)' // Dark grey for subtitle
//           }}
//         >
//           Fill below details to add new user.
//         </Typography>
//       </Box>
//     </Box>
//   </Box>
// </DialogTitle>
      
//       <DialogContent sx={{ p: 3 }}>
//         {formError && (
//           <Typography color="error" sx={{ mb: 2, textAlign: 'center', fontSize: '14px' }}>
//             {formError}
//           </Typography>
//         )}

        

//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 2, sm: 2 } , mb: 2.5, mt: 5}}>
//           <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
//             <InputLabel htmlFor="fullName" sx={externalLabelSx}>
//               Name <span style={{ color: theme.palette.error.main }}>*</span>
//             </InputLabel>
//             <TextField fullWidth autoFocus id="fullName" type="text" variant="outlined" size="small" value={fullName} onChange={handleFullNameChange} placeholder="Enter full name" sx={commonTextFieldSx} error={!!fullNameError} helperText={fullNameError} disabled={isAddingUser} />
//           </Box>

//           <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
//             <InputLabel htmlFor="email" sx={externalLabelSx}>
//               Email <span style={{ color: theme.palette.error.main }}>*</span>
//             </InputLabel>
//             <TextField fullWidth id="email" type="email" variant="outlined" size="small" value={email} onChange={handleEmailChange} placeholder="Enter email address" sx={commonTextFieldSx} error={!!emailError} helperText={emailError} disabled={isAddingUser} />
//           </Box>
//         </Box>
        
//         <Box sx={{ mb: 2.5, width: { xs: '100%', sm: `calc(50% - ${theme.spacing(1)})` } }}>
//             <InputLabel htmlFor="role" sx={externalLabelSx}>
//                 Role <span style={{ color: theme.palette.error.main }}>*</span>
//             </InputLabel>
//             <FormControl fullWidth error={!!roleError}>
//                 <Select
//                     id="role"
//                     value={role}
//                     onChange={handleRoleChange}
//                     displayEmpty
//                     variant="outlined"
//                     size="small"
//                     disabled={isAddingUser}
//                     sx={{ ...commonTextFieldSx, borderRadius: '8px', '& fieldset': { borderColor: '#E8EBEC' }, '& .MuiSelect-select': { display: 'flex', alignItems: 'center' } }}
//                     renderValue={(selectedValue) => {
//                         if (!selectedValue) {
//                             return <Typography sx={{ fontFamily: 'Inter', fontSize: '13px', color: 'rgba(185, 185, 185, 1)' }}>Select role</Typography>;
//                         }
//                         const dotColor = roleDotColors[selectedValue] || theme.palette.action.disabled;
//                         return (
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: dotColor, mr: 1 }}/>
//                                 <Typography component="span" sx={{ color: theme.palette.text.primary,fontSize:'14px' }}>{selectedValue}</Typography>
//                             </Box>
//                         );
//                     }}
//                     MenuProps={{
//                         sx: {
//                             zIndex: 1400,
//                         },
//                     }}
//                 >
//                     {/* 3. "SELECT ROLE" REMOVED FROM THE ACTUAL DROPDOWN LIST */}
//                     <MenuItem value="Admin">
//                         <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '13px' }}>
//                             <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: roleDotColors.Admin, mr: 1 }} />
//                             Admin
//                         </Box>
//                     </MenuItem>
//                     <MenuItem value="Editor">
//                         <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '13px'  }}>
//                             <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: roleDotColors.Editor, mr: 1 }} />
//                             Editor
//                         </Box>
//                     </MenuItem>
//                     <MenuItem value="Viewer">
//                         <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '13px'  }}>
//                             <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: roleDotColors.Viewer, mr: 1 }} />
//                             Viewer
//                         </Box>
//                     </MenuItem>
//                 </Select>
//                 {roleError && <FormHelperText>{roleError}</FormHelperText>}
//             </FormControl>
//         </Box>

//       </DialogContent>
//       <DialogActions sx={{ p: theme.spacing(2, 3) }}>
//         <Button
//           onClick={onClose}
//           variant="outlined"
//           disabled={isAddingUser}
//           sx={{
//             width: '120px',
//             borderRadius: '8px', color: 'rgba(52, 64, 84, 1)', borderColor: 'rgba(208, 213, 221, 1)',
//             '&:hover': { borderColor: theme.palette.grey[700], backgroundColor: 'action.hover' },
//             py: '8px', textTransform: 'none', fontWeight: 500, fontSize: '14px', fontFamily:'Inter',
//           }}
//         >
//           Cancel
//         </Button>
//         <Button
//           type="submit"
//           variant="contained"
//           color="primary"
//           disabled={isAddUserButtonDisabled}
//           sx={{
//             width: '120px',
//             py: '8px', borderRadius:'8px', textTransform: 'none',
//             fontWeight: 500, fontSize: '14px', fontFamily:'Inter',
//             '&.Mui-disabled': {
//                 backgroundColor: 'rgba(224, 224, 224, 1)',
//                 color: 'rgba(173, 173, 173, 1)'
//             }
//           }}
//         >
//           {isAddingUser ? 'Adding...' : 'Add User'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default UserForm;

import React, { useState, useEffect } from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  IconButton,
  Typography,
  useTheme,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  FormControl,
  FormHelperText,
  Snackbar,
  Alert,
} from '@mui/material';
import {
  Close as CloseIcon,
} from '@mui/icons-material';
import { gql, useMutation } from '@apollo/client';


const FORM_ICON_URL = `${process.env.PUBLIC_URL}/formicon.svg`;

interface NewUserFormData {
  user: {
    name: string;
    email: string;
  };
  role: string;
}

interface UserFormProps {
  open: boolean;
  onClose: () => void;
  onUserAdd: (userData: NewUserFormData) => void;
  tenantId: string;
}

const ADD_USER_TO_TENANT = gql`
  mutation AddUserToTenant($input: AddUserToTenantInput!) {
    addUserToTenant(input: $input) {
      message
      invitation {
        id
        email
        nameHint
        roleInTenant
        status
        sentAt
      }
    }
  }
`;

const roleDotColors: { [key: string]: string } = {
  Admin: '#FF9900',
  Editor: '#0064FF',
  Viewer: '#6C737F',
};


// Custom icon component to match the desired style
const CustomErrorIcon = () => (
  <Box
    component="span"
    sx={{
      width: 24,
      height: 24,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#D92D20', // Strong red from the image
    }}
  >
    {/* Using CloseIcon to create the 'x' symbol */}
    <CloseIcon sx={{ color: 'white', fontSize: '16px' }} />
  </Box>
);


const UserForm: React.FC<UserFormProps> = ({ open, onClose, onUserAdd, tenantId }) => {
  const theme = useTheme();

  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');

  const [fullNameError, setFullNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [roleError, setRoleError] = useState('');

  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const [isToastOpen, setIsToastOpen] = useState(false);


  const [addUserToTenantMutation, { loading: isAddingUser }] = useMutation(
    ADD_USER_TO_TENANT,
    {
      onCompleted: (data) => {
        onUserAdd({
          user: { name: fullName.trim(), email: email.trim() },
          role: role,
        });
        onClose();
      },
      onError: (error) => {
        const serverMessage = error.graphQLErrors?.[0]?.message;

        const errorMap: { [key: string]: string } = {
          'A user with this email already exists in the tenant.': 'This email is already registered. Please use a different one.',
        };

        // MODIFIED: The fallback message is now updated.
        const customMessage = errorMap[serverMessage] || serverMessage || 'We are unable to add the user in the tenant at this moment. Please try again after some time.';

        setToastMessage(customMessage);
        setIsToastOpen(true);
      },
    }
  );

  useEffect(() => {
    if (open) {
      setFullName('');
      setEmail('');
      setRole('');
      setFullNameError('');
      setEmailError('');
      setRoleError('');
      setToastMessage(null);
    }
  }, [open]);

    // Validation and handler functions remain the same...
    const validateFullName = (currentName: string): string => {
        if (!currentName.trim()) return 'Name is required.';
        return '';
    };

    const validateEmail = (currentEmail: string): string => {
        if (!currentEmail.trim()) return 'Email is required.';
        if (!/\S+@\S+\.\S+/.test(currentEmail)) return 'Please enter a valid email address.';
        return '';
    };

    const validateRole = (currentRole: string): string => {
        if (!currentRole.trim()) return 'Role is required.';
        return '';
    };

    const handleFullNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFullName(e.target.value);
        if (fullNameError) setFullNameError(validateFullName(e.target.value));
    };

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        if (emailError) setEmailError(validateEmail(e.target.value));
    };

    const handleRoleChange = (event: SelectChangeEvent<string>) => {
        setRole(event.target.value);
        if (roleError) {
            setRoleError(validateRole(event.target.value));
        }
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setToastMessage(null);

        const currentFullNameError = validateFullName(fullName);
        const currentEmailError = validateEmail(email);
        const currentRoleError = validateRole(role);

        setFullNameError(currentFullNameError);
        setEmailError(currentEmailError);
        setRoleError(currentRoleError);

        if (currentFullNameError || currentEmailError || currentRoleError) return;
        if (!tenantId) {
            setToastMessage("Cannot add user: Your session may have expired.");
            setIsToastOpen(true);
            return;
        }

        try {
          await addUserToTenantMutation({
            variables: { input: { email: email.trim(), name: fullName.trim(), tenantId: tenantId, roleInTenant: role.toLowerCase() } },
          });
        } catch (err) {
            // Apollo's onError will handle this
        }
    };

  const handleToastClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsToastOpen(false);
  };


  const isAddUserButtonDisabled = !fullName.trim() || !email.trim() || !role.trim() || isAddingUser;

  const commonTextFieldSx = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '& fieldset': { borderColor: 'rgba(232, 235, 236, 1)' },
      '&:hover fieldset': { borderColor: theme.palette.grey[500] },
    },
    '& .MuiInputBase-input': { fontSize: '13px' },
    '& .MuiInputBase-input::placeholder': { fontSize: '13px', opacity: 1, color: 'rgba(185, 185, 185, 1)', fontFamily: 'Inter' },
  };

  const externalLabelSx = {
    mb: 0.5, fontWeight: 400, fontSize: '12px', color: 'rgba(51, 51, 51, 1)', fontFamily: 'Inter'
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleSubmit,
          sx: { borderRadius: '16px', maxWidth: '600px' }
        }}
        BackdropProps={{ sx: { backdropFilter: 'blur(5px)' } }}
        fullWidth
        sx={{ zIndex: 1301 }}
      >
        <DialogTitle sx={{
          p: theme.spacing(2, 3),
          backgroundImage: `linear-gradient(to bottom, transparent 80%, white 100%), url('/blue-bg-form.svg')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          borderTopRightRadius: '16px',
          borderTopLeftRadius: '16px',
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box component="span" sx={{ mt: 3, width: 48, height: 48, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1.5, backgroundColor:'#E5EFFF', boxShadow: '0px 1px 2px 0px rgba(10, 13, 18, 0.05)' }}>
                <img src={FORM_ICON_URL} alt="Form Icon" style={{ width: '24px'}} />
              </Box>
              <Box>
                <Typography variant="h6" component="div" sx={{ fontFamily:'Inter', fontWeight: 600, fontSize: '16px', mb:0.3, mt: 3, color: 'rgba(3, 23, 52, 1)' }}>
                  Add New User
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontFamily:'Inter', fontSize: '14px', fontWeight: 400, color: 'rgba(71, 84, 103, 1)' }}>
                  Fill below details to add new user.
                </Typography>
              </Box>
            </Box>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 2, sm: 2 } , mb: 2.5, mt: 5}}>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <InputLabel htmlFor="fullName" sx={externalLabelSx}>Name <span style={{ color: theme.palette.error.main }}>*</span></InputLabel>
              <TextField fullWidth autoFocus id="fullName" type="text" variant="outlined" size="small" value={fullName} onChange={handleFullNameChange} placeholder="Enter full name" sx={commonTextFieldSx} error={!!fullNameError} helperText={fullNameError} disabled={isAddingUser} />
            </Box>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <InputLabel htmlFor="email" sx={externalLabelSx}>Email <span style={{ color: theme.palette.error.main }}>*</span></InputLabel>
              <TextField fullWidth id="email" type="email" variant="outlined" size="small" value={email} onChange={handleEmailChange} placeholder="Enter email address" sx={commonTextFieldSx} error={!!emailError} helperText={emailError} disabled={isAddingUser} />
            </Box>
          </Box>
          
          <Box sx={{ mb: 0.5, width: { xs: '100%', sm: `calc(50% - ${theme.spacing(1)})` } }}>
              <InputLabel htmlFor="role" sx={externalLabelSx}>Role <span style={{ color: theme.palette.error.main }}>*</span></InputLabel>
              <FormControl fullWidth error={!!roleError}>
                  <Select
                      id="role"
                      value={role}
                      onChange={handleRoleChange}
                      displayEmpty
                      variant="outlined"
                      size="small"
                      disabled={isAddingUser}
                      sx={{ ...commonTextFieldSx, borderRadius: '8px', '& fieldset': { borderColor: '#E8EBEC' }, '& .MuiSelect-select': { display: 'flex', alignItems: 'center' } }}
                      renderValue={(selectedValue) => {
                          if (!selectedValue) {
                              return <Typography sx={{ fontFamily: 'Inter', fontSize: '13px', color: 'rgba(185, 185, 185, 1)' }}>Select role</Typography>;
                          }
                          const dotColor = roleDotColors[selectedValue] || theme.palette.action.disabled;
                          return (
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: dotColor, mr: 1 }}/>
                                  <Typography component="span" sx={{ color: theme.palette.text.primary,fontSize:'14px' }}>{selectedValue}</Typography>
                              </Box>
                          );
                      }}
                      MenuProps={{ sx: { zIndex: 1400 } }}
                  >
                      <MenuItem value="Admin"><Box sx={{ display: 'flex', alignItems: 'center', fontSize: '13px' }}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: roleDotColors.Admin, mr: 1 }} />Admin</Box></MenuItem>
                      <MenuItem value="Editor"><Box sx={{ display: 'flex', alignItems: 'center', fontSize: '13px'  }}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: roleDotColors.Editor, mr: 1 }} />Editor</Box></MenuItem>
                      <MenuItem value="Viewer"><Box sx={{ display: 'flex', alignItems: 'center', fontSize: '13px'  }}><Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: roleDotColors.Viewer, mr: 1 }} />Viewer</Box></MenuItem>
                  </Select>
                  {roleError && <FormHelperText>{roleError}</FormHelperText>}
              </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: theme.spacing(2, 3) }}>
          <Button onClick={onClose} variant="outlined" disabled={isAddingUser} sx={{ width: '120px', borderRadius: '8px', color: 'rgba(52, 64, 84, 1)', borderColor: 'rgba(208, 213, 221, 1)', '&:hover': { borderColor: theme.palette.grey[700], backgroundColor: 'action.hover' }, py: '8px', textTransform: 'none', fontWeight: 500, fontSize: '14px', fontFamily:'Inter' }}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="primary" disabled={isAddUserButtonDisabled} sx={{ width: '120px', py: '8px', borderRadius:'8px', textTransform: 'none', fontWeight: 500, fontSize: '14px', fontFamily:'Inter', backgroundColor: '#0064FF', '&.Mui-disabled': { backgroundColor: 'rgba(224, 224, 224, 1)', color: 'rgba(173, 173, 173, 1)' } }}>
            {isAddingUser ? 'Adding...' : 'Add User'}
          </Button>
        </DialogActions>
      </Dialog>
      
      <Snackbar
        open={isToastOpen}
        autoHideDuration={6000}
        onClose={handleToastClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          icon={<CustomErrorIcon />} 
          onClose={handleToastClose}
          sx={{
            width: '100%',
            borderRadius: '50px',
            backgroundColor: 'white',
            boxShadow: theme.shadows[3],
            color: 'text.secondary',
            alignItems: 'center',
            p: theme.spacing(0.5, 2),
            '& .MuiAlert-message': {
              flex: 1,
              py: '12px'
            },
          }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UserForm;
